import { http } from '@/core/helpers/axiosHelper';
import { PaginatedResponse } from '@/core/models/PaginatedResponse';
import { EasypayImportFileBatch } from './easypay-import-file-batch.interface';

export class EasypayImportFileBatchService {
   async getEasypayImportFileBatches() {
      return await http.get<PaginatedResponse<EasypayImportFileBatch>>(`/easypay-import-file-batches`).then((response) => response.data);
   }
   async postEasypayImportFileBatches(importBatch: any) {
      return await http
         .post<EasypayImportFileBatch>(`/easypay-import-file-batches`, { method: 'post', ...importBatch })
         .then((response) => response.data);
   }
}
